/**
 * Collections API - Favorites
 *
 * Add, remove, and list favorite collections.
 */

import { z } from 'zod'
import { PaginationMetaSchema } from '../common'
import { CollectionSchema } from './common'

// ============================================================================
// GET /v1/collections/favorites
// ============================================================================

export const ListFavoriteCollectionsResponseSchema = z.object({
  data: z.array(CollectionSchema),
  message: z.string(),
  meta: PaginationMetaSchema
})

export type ListFavoriteCollectionsResponse = z.infer<typeof ListFavoriteCollectionsResponseSchema>

// ============================================================================
// POST /v1/collections/:id/favorite
// ============================================================================

export const CollectionAddFavoriteResponseSchema = z.object({
  data: z.object({ success: z.boolean() }),
  message: z.string()
})

export type CollectionAddFavoriteResponse = z.infer<typeof CollectionAddFavoriteResponseSchema>

// ============================================================================
// DELETE /v1/collections/:id/favorite
// ============================================================================

export const CollectionRemoveFavoriteResponseSchema = z.object({
  data: z.object({ success: z.boolean() }),
  message: z.string()
})

export type CollectionRemoveFavoriteResponse = z.infer<typeof CollectionRemoveFavoriteResponseSchema>
